import React from 'react';

const SecondCom = () => {
  return(
    <div className="vcom2">
      <h3 className="first">Popular Search</h3>
      <div className="second">
        <div className="p1"></div>
        <div className="p2"></div>
        <div className="p3"></div>
        <div className="p4"></div>
      </div>

    </div>
  )
}

export default SecondCom;